module.exports = __webpack_public_path__ + "img/slotmachine.9891e52e.png";